/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IGetInteractionJSONFromNode {
  node: any
  Decoder: (getValues: any, key: string) => any
}

export default function getInteractionJSONFromNode({
  node,
  Decoder
}: IGetInteractionJSONFromNode): any {
  if (node.querySelector('div')) {
    const InteractionJSON = JSON.parse(node.querySelector('div').textContent)
    for (const key in InteractionJSON) {
      InteractionJSON[key] = Decoder(InteractionJSON, key)
    }
    return InteractionJSON
  } else {
    return undefined
  }
}
